<template>
  <div>
    <el-form :inline="true" :model="formInline" ref="formInline">
      <el-form-item label="设备编号" prop="deviceId">
        <el-input
          v-model="formInline.deviceId"
          placeholder="设备编号"
        ></el-input>
      </el-form-item>
      <el-form-item label="到期天数" prop="maturityDays">
        <el-input
          v-model="formInline.maturityDays"
          placeholder="到期天数"
        ></el-input>
      </el-form-item>
      <el-form-item label="机构名称" prop="referName">
        <el-input
          v-model="formInline.referName"
          placeholder="机构名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search('formInline')">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="reset('formInline')">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="data" border stripe style="width: 100%">
      <el-table-column prop="deviceId" label="设备编号"> </el-table-column>
      <el-table-column prop="serviceNo" label="服务编号"> </el-table-column>
      <el-table-column prop="outBillNo" label="出库编号"> </el-table-column>
      <el-table-column prop="crm" label="CRM订单号"> </el-table-column>
      <el-table-column prop="referName" label="机构名称"> </el-table-column>
      <el-table-column prop="startTime" label="开始时间"> </el-table-column>
      <el-table-column prop="endTime" label="结束时间"> </el-table-column>
      <el-table-column prop="maturityDays" label="到期天数"> </el-table-column>
    </el-table>
    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
  data() {
    return {
      formInline: {
        deviceId: "",
        maturityDays: "",
        referName: "",
      },
      data: [],
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
  methods: {
    search(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.pagin.pageNum = 1;
          this.getList();
        }
      });
    },
    getList() {
      //数据绑定
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
        ...this.formInline,
      };
      this.$http
        .post("/manage/outService/listPageDeviceExpiration", params)
        .then((results) => {
          this.data = results["data"]["data"]["records"];
          this.pagin.total = results["data"]["data"]["total"];
        });
    },
    reset(formName) {
      this.$refs[formName].resetFields();
      this.pagin.pageNum = 1;
      this.getList();
    },
  },
  components: { Pagination },
};
</script>
